import React from 'react';
import RenderOptionTextComp from './RenderOptionTextComp';

function WordSearchInputList() {
  return <>
    <RenderOptionTextComp
      initialOptions={['']}
      placeholderText={'Puzzle word'}
      minLength={1}
      maxLength={10}
    />
  </>
}

function SpinAWheelInputList() {
  return <>
    <RenderOptionTextComp
      initialOptions={['', '']}
      placeholderText={'Option'}
      minLength={2}
      maxLength={10}
    />
  </>
}

export {WordSearchInputList, SpinAWheelInputList};